// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCtfHFB-Q8NxWk6zUrLFg7KJdEk94Hl3lQ",
  authDomain: "interview-app-8aeeb.firebaseapp.com",
  projectId: "interview-app-8aeeb",
  storageBucket: "interview-app-8aeeb.appspot.com",
  messagingSenderId: "246930436214",
  appId: "1:246930436214:web:521f9586bafbc004d52f57",
  measurementId: "G-Y1FLXFJ41C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app)

export const auth = getAuth(app);